// C:\Projects\texe\texe-web\src\pages\MyProfileRedirect.tsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function MyProfileRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={`/u/${user.username}`} replace />;
}
